module.exports = __webpack_public_path__ + "media/images/icons/icon_contact_off-6d591b751790f90240c914067c7ada17.svg";